module.exports = __webpack_public_path__ + "static/media/Public_28.ef616261.jpg";